import React, { SyntheticEvent, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { Icon, Button, Dropdown, Input, Popup, TransitionablePortal, Segment } from "semantic-ui-react";
import Cookies from "js-cookie";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import { formatComma } from "react-lib/apps/common/PureReactTable";
import { getChromeMajorVersion } from "react-lib/utils/chromeVersion";

const SubTreatmentPerformRow = (props: any) => {
  const intl = useIntl();
  const [treatmentCodeWidth, setTreatmentCodeWidth] = useState(100);
  const [treatmentCodeY, setTreatmentCodeY] = useState(0);
  const [avaliableTreatmentCodeWidth, setAvaliableTreatmentCodeWidth] = useState(0);
  const parentTreatmentCodeRef = useRef(null);
  const dropdownDivRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dynamicTreatmentOptions, setDynamicTreatmentOptions] = useState<any[]>([]);
  const [modConfirmData, setModConfirmData] = useState<any>({ open: false, product: null });
  const [openModPriceLevel, setOpenModPriceLevel] = useState<any>({});
  const [adjustRemark, setAdjustRemark] = useState("");
  const [customPrice, setCustomPrice] = useState<string | null>(null);
  const [additionRemark, setAdditionRemark] = useState<string | null>(null);
  // const popupRef = useRef<any>(null)
  const [popupTreatmentCodeOpen, setPopupTreatmentCodeOpen] = useState(false);
  const [popupPriceLevelOpen, setPopupPriceLevelOpen] = useState(false);

  const PRICE_LEVEL_OPTIONS = [
    { key: "LEVEL_1", value: "LEVEL_1", text: "ระดับ 1" },
    { key: "LEVEL_2", value: "LEVEL_2", text: "ระดับ 2" },
    { key: "LEVEL_3", value: "LEVEL_3", text: "ระดับ 3" },
    { key: "CUSTOM", value: "CUSTOM", text: "แพทย์กำหนดเอง" },
  ];

  // const ADJUST_REMARK = [
  //   "ตรวจโดยไม่ได้รักษา",
  //   "งานตัดไหม",
  //   "งานไม่ฟุ้งกระจาย",
  //   "ให้ส่วนลดผู้ป่วยพิเศษในโครงการวิจัย",
  //   "ใช้ในงานวิจัย",
  //   "ใส่ฟันซ่อม",
  //   "lab/อุปกรณ์ไม่พร้อม",
  //   "คนรู้จัก",
  //   "คนไข้เก่า",
  //   "ญาติ",
  //   "ผู้ป่วย VIP",
  //   "มีปัญหาเรื่องค่าใช้จ่าย",
  //   "ผู้ป่วยไม่มีอาการแล้ว",
  //   "ผู้ป่วยได้สิทธิสังคมสงเคราะห์",
  //   "ประกอบการเรียนการสอน",
  //   "อื่นๆ",
  // ];

  // const ADJUST_REMARK_OPTIONS = useMemo(() => ADJUST_REMARK.map((i) => ({ key: i, value: i, text: i })), []);

  // const isTreatmentPerformReadOnly = useMemo(() => {
  //   // const status = props.encounterInfo?.status || "";

  //   // return ["CHECKED_OUT", "DISCHARGED", "WAIT_DISPENSE", "WAIT_PAY"].includes(status) || !!props.readOnly;
  //   return props.readOnly
  // }, [props.encounterInfo, props.readOnly]);

  const debounce = useCallback((callback: any, wait: any) => {
    let timeoutId: any = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback(...args);
      }, wait);
    };
  }, []);

  const allowedEditPriceLevel = useMemo(() => {
    const options: Record<string, any>[] = props.divisionHasUserOptions || [];
    const hasPriceEditPermission = options.some((option) => (option.useRights as string[]).includes("แก้ไขระดับราคาและส่วนลดค่าบริการ"));

    return !!props.treatmentPerform?.product && hasPriceEditPermission;
  }, [props.divisionHasUserOptions, props.treatmentPerform]);

  const handleChangeTreatmentCode = (_event: any, data: any) => {
    if (props.treatmentPerform?.treatment?.divisions.includes(Number(Cookies.get("division_id")))) {
      props.handleEvent({
        message: "handleUpdateTreatmentPlanIssue",
        params: {
          pk: props.treatmentPerform?.id,
          exam_id: props.treatmentPerform?.treatment_plan?.examination,
          plan_id: props.treatmentPerform?.treatment_plan?.id,
          product: data.value,
        },
      });
      closeModConfirmData();
    } else {
      setModConfirmData({ open: true, product: data.value });
    }
  };

  // const handleChangePriceLevel = (_event: any, data: any) => {
  //   if (props.treatmentPerform?.treatment?.divisions.includes(Number(Cookies.get("division_id")))) {
  //     props.handleEvent({
  //       message: "handleUpdateTreatmentPlanIssue",
  //       params: {
  //         pk: props.treatmentPerform?.id,
  //         exam_id: props.treatmentPerform?.treatment_plan?.examination,
  //         plan_id: props.treatmentPerform?.treatment_plan?.id,
  //         product: data.value,
  //       },
  //     });
  //     closeModConfirmData();
  //   } else {
  //     setModConfirmData({ open: true, product: data.value });
  //   }
  // };

  const getStringThatFitsWidth = useCallback((input, width, style) => {
    // Create a temporary element for measuring text width
    const tempElement = document.createElement("span");
    tempElement.style = style;
    tempElement.style.position = "absolute";
    tempElement.style.visibility = "hidden";
    tempElement.style.whiteSpace = "nowrap";
    document.body.appendChild(tempElement);

    let fittingString = "";

    for (let i = 1; i <= input.length; i++) {
      const substring = input.slice(0, i);
      tempElement.textContent = substring; // Measure width of the substring
      const substringWidth = tempElement.offsetWidth;

      if (substringWidth > width) {
        break; // Stop when the substring exceeds the specified width
      }

      fittingString = substring;
    }

    // Remove the temporary element
    document.body.removeChild(tempElement);

    return fittingString;
  }, []);

  const closeModConfirmData = () => {
    setModConfirmData({ open: false, product: null });
  };

  useEffect(() => {
    if (props.treatmentPerform?.adjusted_remark && !props.priceChangeReasonOptions?.some((i: any) => i.text === props.treatmentPerform?.adjusted_remark)) {
      setAdditionRemark(props.treatmentPerform?.adjusted_remark);
    }
  }, [props.treatmentPerform?.adjusted_remark]);

  const combineOptions = [...props.priceChangeReasonOptions, ...(additionRemark ? [{ key: additionRemark, value: additionRemark, text: additionRemark }] : [])];

  // let zoom = 0.65
  // let top = top * zoom - y;
  // let left = left * zoom - x;

  // const disableRemovePerform = !!(props.treatmentPerform?.product && props.readOnly && ["CHECKED_OUT", "DISCHARGED", "WAIT_DISPENSE", "WAIT_PAY"].includes(props.encounterInfo?.status))

  const recalText = useCallback(
    () => {
      if (dropdownRef?.current && dropdownRef?.current?.searchRef?.current && avaliableTreatmentCodeWidth) {
        const styles = window.getComputedStyle(dropdownRef?.current?.searchRef?.current);
        let options = props.treatmentPerform?.parentRow ? props.treatmentPerform?.treatment?.trt_product_list || [] : props.treatmentOptions;
        let adjustMenu: any[] = options
          ?.filter((a: any) => a.value === props.treatmentPerform?.product)
          .map((a: any) => ({ ...a, text: getStringThatFitsWidth(a.text, avaliableTreatmentCodeWidth, styles) }));
        // console.log('adjustMenu: ', adjustMenu);
        setDynamicTreatmentOptions(adjustMenu);
      }
    },
    [dropdownRef?.current, avaliableTreatmentCodeWidth,  props.treatmentPerform?.product, props.treatmentPerform?.parentRow, props.treatmentPerform?.treatment?.trt_product_list, props.treatmentOptions]
  );

  useEffect(() => {
    if (dropdownRef?.current && dropdownRef?.current?.searchRef?.current && avaliableTreatmentCodeWidth) {
      const styles = window.getComputedStyle(dropdownRef?.current?.searchRef?.current);
      let options = props.treatmentPerform?.parentRow ? props.treatmentPerform?.treatment?.trt_product_list || [] : props.treatmentOptions;
      let adjustMenu: any[] = options
        ?.filter((a: any) => a.value === props.treatmentPerform?.product)
        .map((a: any) => ({ ...a, text: getStringThatFitsWidth(a.text, avaliableTreatmentCodeWidth, styles) }));
      // console.log('adjustMenu: ', adjustMenu);
      setDynamicTreatmentOptions(adjustMenu);
    }
  }, [avaliableTreatmentCodeWidth]);

  const resizeRecal = useCallback(
    (currentStyle?: any) => {
      if (dropdownRef?.current) {
        const styles = window.getComputedStyle(currentStyle || dropdownRef?.current?.searchRef?.current);
        let paddingLeft = parseFloat(styles.paddingLeft);
        let paddingRight = parseFloat(styles.paddingRight);
        let width = parseFloat(styles.width);
        const availableWidth = width - paddingLeft - paddingRight; // Width in pixels
        debounce(() => {
          setAvaliableTreatmentCodeWidth(Math.round(availableWidth));
        }, 25)();
      }
    },
    [props.treatmentPerform?.parentRow, props.treatmentPerform?.treatment?.trt_product_list, props.treatmentOptions, parentTreatmentCodeRef?.current]
  );

  const handleResize = useCallback(
    debounce(() => {
      // console.log('handleResize: called !!');
      if (parentTreatmentCodeRef?.current) {
        let width = parentTreatmentCodeRef?.current?.clientWidth;
        if (dropdownDivRef?.current) {
          dropdownDivRef.current.style.marginLeft = `${width * 0.1}px`;
          dropdownDivRef.current.style.width = `${width * 0.8}px`;
        }
        resizeRecal();
        // handleScroll();
      }
    }, 15),
    [parentTreatmentCodeRef?.current]
  );

  useEffect(() => {
    console.log("useEffect: addEvent listener  resize");
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // const handleScroll = useCallback(
  //   debounce(() => {
  //     console.log(" handleScroll ");
  //     if (parentTreatmentCodeRef?.current) {
  //       let cur = parentTreatmentCodeRef?.current;
  //       let rect = cur?.getBoundingClientRect();
  //       console.log('handleScroll rect: ', rect);
  //       console.log('handleScroll cur: ', cur);
  //       console.log('handleScroll cur?.currentCSSZoom: ', cur?.currentCSSZoom);
 
  //       console.log('handleScroll_1 rect?.y / cur?.currentCSSZoom: ',  rect?.y / cur?.currentCSSZoom);
  //       console.log('handleScroll_1 rect?.x / cur?.currentCSSZoom: ',  rect?.x / cur?.currentCSSZoom);

  //       if (dropdownDivRef?.current) {
  //         // dropdownDivRef.current.style.top = `${rect?.y / cur?.currentCSSZoom}px`;
  //         // dropdownDivRef.current.style.left = `${rect?.x / cur?.currentCSSZoom}px`;
  //       }
  //     }
  //   }, 15),
  //   [parentTreatmentCodeRef?.current]
  // );

  // useEffect(() => {
  //   handleScroll();
  //   document.querySelector("#main-dpo")?.addEventListener("scroll", handleScroll);
  //   return () => {
  //     document.querySelector("#main-dpo")?.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  useEffect(() => {
    resizeRecal();
  }, [props.treatmentPerform?.parentRow, props.treatmentOptions, props.treatmentPerform?.treatment?.trt_product_list]);

  // useEffect(() => {
  //   handleScroll();
  // }, [props.totalRows]);

  useEffect(() => {
    if (dropdownRef?.current && dropdownRef?.current?.searchRef?.current && avaliableTreatmentCodeWidth) {
      const styles = window.getComputedStyle(dropdownRef?.current?.searchRef?.current);
      let options = props.treatmentPerform?.parentRow ? props.treatmentPerform?.treatment?.trt_product_list || [] : props.treatmentOptions;
      let adjustMenu: any[] = options
        ?.filter((a: any) => a.value === props.treatmentPerform?.product)
        .map((a: any) => ({ ...a, text: getStringThatFitsWidth(a.text, avaliableTreatmentCodeWidth, styles) }));
      // console.log('adjustMenu: ', adjustMenu);
      setDynamicTreatmentOptions(adjustMenu);
    }
  }, [props.treatmentPerform?.product])
  


  console.log(" SubTreatmentPerformRow avaliableTreatmentCodeWidth: ", avaliableTreatmentCodeWidth);
  return (
    <div
      key={props.treatmentPerform.id}
      className={props.readOnly ? `ui form --override-disabled --grey ${props.treatmentPerform.is_paid ? "paid-disabled" : ""}` : ""}
      style={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: props.gridTemplateColumnsTreatmentPerform,
        ...(!props.treatmentPerform?.haveSubRow && { borderBottom: props.styles.borderStyle }),
      }}
    >
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {!props.treatmentPerform?.parentRow ? (
          ""
        ) : (
          <>
            <span style={{ cursor: "pointer" }}>
              <Icon
                name="minus circle"
                color="red"
                size="large"
                disabled={props.treatmentPerform?.continue_treatment_plan || props.disabledRemoveBtn}
                className={"ignore-prevent"}
                style={{ marginRight: "10px" }}
                onClick={(event: any) => {
                  props.handleEvent({
                    message: "handleUpdateTreatmentPlan",
                    params: {
                      pk: props.treatmentPerform?.treatment_plan?.id,
                      exam_id: props.treatmentPerform?.treatment_plan?.examination,
                      status: props.treatmentPerform?.treatment_plan?.previous_status,
                      division: props.treatmentPerform?.treatment_plan?.previous_division,
                      doctor: props.treatmentPerform?.treatment_plan?.previous_doctor,
                    },
                  });

                  props.handleEvent({
                    message: "handleUpdateTreatmentPlanIssue",
                    params: {
                      inactiveAllIssue: true,
                      plan_id: props.treatmentPerform?.treatment_plan?.id,
                      active: false,
                    },
                  });
                }}
              />
            </span>
            <Button
              // color="yellow"
              size="mini"
              disabled={props.treatmentPerform?.continue_treatment_plan || props.disabledContinueBtn}
              // #70021
              className={"ignore-prevent"}
              style={{ backgroundColor: "#CC661C", color: "white" }}
              onClick={(event) => {
                props.handleEvent({
                  message: "handleDuplicateTreatmentPlan",
                  params: { data: props.treatmentPerform },
                });
              }}
            >
              {intl.formatMessage({ id: "cukey60" })}
            </Button>
          </>
        )}
      </div>
      <div style={props.styles.labelStyle}>{!props.treatmentPerform?.parentRow ? "" : props.treatmentPerform?.treatment?.name}</div>
      <div style={props.styles.labelStyle}>{!props.treatmentPerform?.parentRow ? "" : props.treatmentPerform?.treatment_plan?.examination_location}</div>
      <div ref={parentTreatmentCodeRef} style={{ width: "100%", display: "flex", alignItems: "center", gap: "2px", justifyContent: "space-between" }}>
        <span style={{ cursor: "pointer" }}>
          {props.treatmentPerform?.parentRow ? (
            <Icon
              name="plus circle"
              size="large"
              style={{ cursor: "pointer" }}
              color="green"
              disabled={props.readOnly}
              onClick={() => {
                if (!props.hideMenuHIS) {
                  props.handleEvent({
                    message: "AddTreatmentPlanIssue",
                    params: {
                      encounterId: props.treatmentPerform?.encounter,
                      examId: props.treatmentPerform?.treatment_plan?.examination,
                      planId: props.treatmentPerform?.treatment_plan?.id,
                    },
                  });
                }
              }}
            />
          ) : null}
        </span>
        <span
          style={{
            // marginLeft: `${treatmentCodeWidth * 0.1}px`,
            padding: "0.15rem",
            position: "absolute",
            // width: `${treatmentCodeWidth * 0.8}px`,
          }}
          ref={dropdownDivRef}
        >
          <Dropdown
            ref={dropdownRef}
            fluid
            selection
            search
            clearable
            open={popupTreatmentCodeOpen}
            disabled={props.readOnly || props.hideMenuHIS}
            // options={props.treatmentPerform?.parentRow ? props.treatmentPerform?.treatment?.trt_product_list || [] : props.treatmentOptions}
            options={dynamicTreatmentOptions}
            value={props.treatmentPerform?.product}
            onChange={(e, data) => {
              handleChangeTreatmentCode(e, data);
            }}
            onClose={(event: SyntheticEvent, data: any) => {
              recalText();
              setPopupTreatmentCodeOpen(false);
            }}
            onOpen={() => {
              setDynamicTreatmentOptions(
                props.treatmentPerform?.parentRow ? props.treatmentPerform?.treatment?.trt_product_list || [] : props.treatmentOptions
              );
              setPopupTreatmentCodeOpen(true);
            }}
          />
        </span>

        <span style={{ cursor: "pointer" }}>
          {!props.treatmentPerform?.parentRow ? (
            <Icon
              name="remove circle"
              size="large"
              style={{ cursor: "pointer" }}
              color="red"
              disabled={props.readOnly || props.hideMenuHIS}
              onClick={() => {
                if (!props.hideMenuHIS) {
                  props.handleEvent({
                    message: "handleUpdateTreatmentPlanIssue",
                    params: {
                      pk: props.treatmentPerform?.id,
                      exam_id: props.treatmentPerform?.treatment_plan?.examination,
                      plan_id: props.treatmentPerform?.treatment_plan?.id,
                      active: false,
                    },
                  });
                }
              }}
            />
          ) : null}
        </span>
      </div>
      <div style={{ ...props.styles.centerStyle, width: "100%", gap: "10px", padding: "2px 10px" }}>
        <Popup
          flowing
          on="click"
          open={popupPriceLevelOpen}
          onOpen={() => {
            setPopupPriceLevelOpen(true);
          }}
          onClose={() => {
            setPopupPriceLevelOpen(false);
          }}
          style={{ position: "relative", ...(getChromeMajorVersion() < 125 && { left: "-300px", top: "-20px" }) }}
          trigger={
            <Dropdown
              fluid
              selection
              search
              options={PRICE_LEVEL_OPTIONS}
              disabled={!allowedEditPriceLevel || props.readOnly}
              // style={{ position: "absolute", width: "13.8%" }}
              value={props.treatmentPerform?.adjusted_price_level || props.treatmentPerform?.original_price_level || ""}
              open={false}
            />
          }
          disabled={!allowedEditPriceLevel || props.readOnly || props.hideMenuHIS}
          content={
            <Dropdown
              style={{ width: "300px" }}
              fluid
              selection
              search
              options={PRICE_LEVEL_OPTIONS}
              disabled={!allowedEditPriceLevel || props.hideMenuHIS}
              // style={{ position: "absolute", width: "13.8%" }}
              value={props.treatmentPerform?.adjusted_price_level || props.treatmentPerform?.original_price_level || ""}
              onChange={(e, { value }) => {
                console.log("Dropdown PRICE_LEVEL_OPTIONS onChange !! value: ", value);
                console.log("Dropdown props.treatmentPerform?.adjusted_remark: ", props.treatmentPerform?.adjusted_remark);
                setPopupPriceLevelOpen(false);
                // TODO: set Default to remark, price
                // setAdjustRemark("");
                // setCustomPrice(null);

                if (props.treatmentPerform?.adjusted_remark) {
                  setAdjustRemark(props.treatmentPerform?.adjusted_remark);
                } else {
                  setAdjustRemark("");
                }

                if (props.treatmentPerform?.custom_level_price) {
                  setCustomPrice(props.treatmentPerform?.custom_level_price);
                } else {
                  setCustomPrice(null);
                }

                setOpenModPriceLevel({
                  priceLevel: value,
                  open: true,
                });
              }}
            />
          }
        />

        <Button
          disabled={!allowedEditPriceLevel || props.readOnly || props.hideMenuHIS}
          color="yellow"
          icon
          onClick={() => {
            if (!props.hideMenuHIS) {
              setOpenModPriceLevel({ open: true });
            }
          }}
        >
          <Icon name="edit" />
        </Button>
      </div>
      <div
        style={{
          ...props.styles.rightLable,
          ...((props.treatmentPerform?.adjusted_price_level || props.treatmentPerform?.original_price_level || "") === "CUSTOM" && {
            cursor: "pointer",
            backgroundColor: "#ffffd5",
          }),
        }}
        onClick={() => {
          if ((props.treatmentPerform?.adjusted_price_level || props.treatmentPerform?.original_price_level || "") === "CUSTOM" && !props.readOnly) {
            setOpenModPriceLevel({
              open: true,
              priceLevel: "CUSTOM",
            });
          }
        }}
      >
        {formatComma(props.treatmentPerform?.unit_price)}
      </div>
      <div style={props.styles.centerStyle}>
        <Input
          className="ignore-prevent"
          id="ignore-prevent"
          min={0}
          style={{ textAlign: "right", width: "100%" }}
          type="number"
          value={props.treatmentPerform?.quantity || 1}
          disabled={props.readOnly || props.hideMenuHIS}
          onChange={(e, data) => {
            if (!props.hideMenuHIS) {
              props.changeUnit(props.treatmentPerform?.id, data.value);

              // props.setProp(`treatmentPerformList.${props.index}.quantity`, data.value);
            }
          }}
          onBlur={(e: any) => {
            if (!props.hideMenuHIS) {
              props.handleEvent({
                message: "handleUpdateTreatmentPlanIssue",
                params: {
                  pk: props.treatmentPerform?.id,
                  exam_id: props.treatmentPerform?.treatment_plan?.examination,
                  plan_id: props.treatmentPerform?.treatment_plan?.id,
                  quantity: props.treatmentPerform?.quantity,
                },
              });
            }
          }}
        />
      </div>
      {/** Total Fee **/}
      <div style={{ ...props.styles.rightLable, justifyContent: "flex-end", gap: "6px" }}>
        {formatComma(props.treatmentPerform?.unit_price * props.treatmentPerform?.quantity)}
        <div>
          {props.treatmentPerform?.is_paid ? (
            <Button circular size="mini" basic color="green">
              <Icon name="check circle outline" /> PAID
            </Button>
          ) : null}
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        {props.treatmentPerform?.parentRow ? (
          props.selectedTreatmentPerform?.id !== props.treatmentPerform.id &&
          (props.treatmentPerform?.anesthetics?.length > 0 || props.treatmentPerform?.treatment_record) ? (
            <img
              src="/static/images/haveRecord.png"
              style={{ width: "25px", cursor: "pointer" }}
              onClick={() => {
                props.handleSelectedTreatmentRecord(props.treatmentPerform);
              }}
            />
          ) : (
            <Icon
              className="ignore-prevent"
              name={props.selectedTreatmentPerform?.id === props.treatmentPerform.id ? "folder open outline" : "folder outline"}
              color="blue"
              size="large"
              style={{ cursor: "pointer" }}
              onClick={(event: any) => {
                props.handleSelectedTreatmentRecord(props.treatmentPerform);
              }}
            />
          )
        ) : null}
      </div>

      <ModConfirm
        openModal={!!openModPriceLevel?.open}
        titleName="ระบุราคาและเหตุผลลำหรับการแก้ไข"
        backgroundColor={"red"}
        disabledApproveButton={openModPriceLevel?.priceLevel === "CUSTOM" ? !customPrice || !adjustRemark : !adjustRemark}
        content={
          <>
            {openModPriceLevel?.priceLevel === "CUSTOM" ? (
              <>
                <div style={{ margin: "4px 0px" }}>
                  {" "}
                  ระบุราคา <span style={{ color: "red" }}>*</span>
                </div>
                <Input
                  fluid
                  value={customPrice !== null ? customPrice : props.treatmentPerform?.custom_level_price}
                  onChange={(e, { value }) => {
                    setCustomPrice(value);
                  }}
                />
              </>
            ) : null}
            <div style={{ margin: "4px 0px" }}>
              {" "}
              เหตุผลในการเปลี่ยนแปลงราคา <span style={{ color: "red" }}>*</span>
            </div>
            <Dropdown
              placeholder="กรุณาเลือกเหตุผล"
              search
              selection
              allowAdditions
              additionLabel="เพิ่ม: "
              fluid
              options={combineOptions}
              value={adjustRemark || props.treatmentPerform?.adjusted_remark}
              onAddItem={(e, { value }) => {
                console.log("onAddItem value: ", value);
                setAdditionRemark(value as string);
                setAdjustRemark(value as string);
              }}
              onChange={(e, { value }) => {
                setAdjustRemark(value as string);
              }}
            />
          </>
        }
        onApprove={() => {
          props.handleEvent({
            message: "handleUpdateTreatmentPlanIssue",
            params: {
              pk: props.treatmentPerform?.id,
              exam_id: props.treatmentPerform?.treatment_plan?.examination,
              plan_id: props.treatmentPerform?.treatment_plan?.id,
              ...(openModPriceLevel?.priceLevel && { adjusted_price_level: openModPriceLevel?.priceLevel }),
              ...((customPrice || props.treatmentPerform?.customPrice) && { custom_level_price: customPrice || props.treatmentPerform?.customPrice }),
              ...((adjustRemark || props.treatmentPerform?.adjusted_remark) && { adjusted_remark: adjustRemark || props.treatmentPerform?.adjusted_remark }),
            },
          });
          setOpenModPriceLevel({ open: false });
        }}
        onDeny={() => {
          // set back to original value
          setOpenModPriceLevel({ open: false });
        }}
        onCloseWithDimmerClick={() => {
          // set back to original value
          setOpenModPriceLevel({ open: false });
        }}
      ></ModConfirm>

      <ModConfirm
        titleName="แจ้งเตือน !"
        openModal={modConfirmData?.open}
        content={<div>ทันตแพทย์ลงรหัสการรักษานอกแผนกปฏิบัติการ ระบบส่งบันทึก Sensitive report สำหรับแสดง Transaction ที่ไม่เป็นไปตามเงื่อนไข</div>}
        onApprove={() => {
          props.handleEvent({
            message: "handleUpdateTreatmentPlanIssue",
            params: {
              pk: props.treatmentPerform?.id,
              exam_id: props.treatmentPerform?.treatment_plan?.examination,
              plan_id: props.treatmentPerform?.treatment_plan?.id,
              product: modConfirmData.product,
              product_out_perform_div: true,
            },
          });
          closeModConfirmData();
        }}
        onDeny={closeModConfirmData}
        onCloseWithDimmerClick={closeModConfirmData}
      />
    </div>
  );
};

export default SubTreatmentPerformRow;
